var Proj= function (){
	this.menu; //здесь методы манипуляции с меню 
	this.contentSwitcher; //здесь методы переключалки блока с преимуществами
	this.textSlider; //здесь методы переключалки тестового слайдеара
	this.scroll; //здесь методы при скроле страницы
	this.map; //здесь методы манипуляций с картой
	this.forms; //здесь методы манипуляций с формами
}

var proj = new Proj;